var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404NotFoundSleepingRabbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 879.06,
    height: 850.58,
    viewBox: "0 0 879.06 850.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-112.851 -837.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3372",
    "data-name": "Fill 3372",
    d: "M367.282,10.573c-20.9.135-72.314,5.637-94.458,11.96-62.472,17.838-21.67,2.631-78.458,23.959-17.426,5.3-24.27,6.549-41.551,16.594-67.423,39.2-76.754,49.173-104.886,82.186-13.318,13.436-13.7,14.332-13.625,14.26-10.148,10.407-17.255,11.727-25.71,27.431-5.947,11.042-3.7,17.978-5.445,19.45-6.549,5.558-2,15.658,5.575,15.658,16.21,0,63.7,55.442,109.231,102.374,4.04,4.162,61.136,83.5,98.4,114.972,7.684,6.5,16.419,25.378,54.146,39.508,7.535,2.816,24.561,5.974,24.439,5.958,59.047,11.655,95-27.071,151.052-67.426,21.745-12.494,82.383-37.071,101.106-51.237,11.817-8.919,3.736-3.614,31.716-14.6,4.447-1.745,28.4-13.252,39.038-20.478,4.164-2.824,12.108-9.818,20.667-20.076,12.408-14.867,31.637-15.032,38.3-56.529,4.057-25.312-18.309-43.765-27.8-55.7-22.87-28.751-25.012-35.964-36.738-49.212-30.988-35.033-25.842-23.247-53.438-59.269-26.863-35.051-27.324-29.365-54.063-49.874-1.431-1.1-25.12-16.425-26.454-17.218C465.553,15.673,450.451,3.907,434.12.809c-22.4-4.244-39.52,9.586-66.838,9.764",
    transform: "translate(314.601 1201.339)",
    fill: "#e8ddd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3379",
    "data-name": "Fill 3379",
    d: "M0,1.736c8.268-3.905-.075,0,0,0",
    transform: "translate(427.492 1178.55)",
    fill: "#ece1d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3380",
    "data-name": "Fill 3380",
    d: "M88.8,297.4h0c-13.84,0-35.855-9.432-51.487-30.139l-.09-.114c-3.378-4.285-33.082-42.114-35.926-50.932A30,30,0,0,1,.277,203.352a25.243,25.243,0,0,1,3.551-10.445l.439-.653c3.877-5.779,3.877-5.779,22.026-19.346L28.845,171c7.257-10.661,18.85-20.548,27.3-26.965a194.98,194.98,0,0,1,31.4-19.594,99.966,99.966,0,0,0,13.033-7.557,81.582,81.582,0,0,1,18.147-9.479,161.791,161.791,0,0,1,14.832-9.576c4.41-2.623,8.97-5.336,13.236-8.4,1.207-.867,2.265-1.635,3.2-2.312L150,87.1c7.5-5.446,7.954-5.772,24.554-13.451C193,64.793,207.071,57.465,218.379,51.578c13.847-7.21,24.785-12.9,36.593-17.739,12.392-5.074,25.6-9.117,42.837-13.109C321.151,15.315,354.988,9.978,393.088,5.7,408.373,3.986,423.58,2.53,437.064,1.49,449.528.529,459.6,0,465.423,0a91.345,91.345,0,0,1,15.262,1.052A41.316,41.316,0,0,1,493.4,5.194c8.03,4.274,14.32,11.726,19.8,23.451a102.532,102.532,0,0,1,7.6,26.2c1.2,7.774,2,18.839-1,27.4-3.377,9.637-7.975,17.269-14.055,23.332a57.369,57.369,0,0,1-21.077,13.036c-16.294,6.054-37.224,7.647-61.46,9.491-17.583,1.338-37.511,2.855-59.043,6.329-22.972,4.767-29.751,8.04-38.332,12.183-3.31,1.6-6.734,3.251-11.457,5.2-28.133,11.585-34.017,15-39.706,18.3a153.6,153.6,0,0,1-17.053,8.607c-4.75,2.12-6.515,2.787-7.57,3.186-1.367.517-1.367.517-5.16,2.717-2.96,1.718-8.47,4.915-18.983,10.873-5.334,3.025-7.891,4.278-9.757,5.192-3.506,1.718-4.138,2.028-15.476,10.408-10.119,7.476-14.226,10.107-17.224,12.028a67.563,67.563,0,0,0-6.482,4.565c-9.324,7.965-11.165,9.244-14.834,11.793-1.063.738-2.267,1.575-3.85,2.711-7.278,5.211-12.8,11.245-18.652,17.634-5.1,5.567-10.366,11.323-16.958,16.571a65.441,65.441,0,0,1-9.788,10.8c-9.448,8.158-13,8.745-18.886,9.716l-.956.159A25.621,25.621,0,0,1,88.8,297.4ZM476.663,72.187a4.652,4.652,0,0,1-.393.3c-.117.082-.188.132-.179.161s.091.039.325.039c.109,0,.249,0,.425,0l.207,0c.235,0,.555-.008.939-.008h.213c.33,0,.5-.019.5-.056A10.694,10.694,0,0,0,476.663,72.187Z",
    transform: "translate(221.012 1122.897)",
    fill: "#ece1d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3381",
    "data-name": "Fill 3381",
    d: "M585.549,232.763c-3.212-14.337-3.549-33.143-9.329-50.56-7.342-22.118-10.959-43.024-13.1-49.806-4.836-15.367-9.967-32.393-15.883-67.706-1.533-9.16-2.377-7.758-4.459-19.8C539.345,25.047,529.357-2.6,507.3.2c-5.924.75-12.025,3-18.255,4.265-22.937,4.652-46.995,5.173-70.123,9.751C281.253,41.465,218.382,97.662,142.465,131.266c-15.577,6.894-27.862,21.331-40.27,32.443C90.071,174.567,76.34,184.8,65.26,196.651,57.634,204.81,52.8,212.785,43.623,219.8c-51.19,39.148-64.587,49.648-.42,133.064.055.072,77.875,96.133,85.72,102.729,4.166,3.5,5.457,7.719,11.667,8.066,6.746.378,17.451-7.78,23.295-11.115,16.323-9.316,30.382-21.541,44.025-34.18,13.111-12.147,58.7-32.862,104.264-60.148,4.324-2.59,43.706-18.585,54.183-21.11,43.658-10.522,18.662-8.017,69.663-18.782,44.568-9.407,47.229-6.435,99.918-9.438,50.973-2.906,51.771-3.306,51.771-21.275,0-27.3,4.081-26.979-2.16-54.851",
    transform: "translate(112.851 837.748)",
    fill: "#f1e6d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3382",
    "data-name": "Fill 3382",
    d: "M32.786,18.892c-1.1,3.93.4,3.643-3.122.34-9.933-9.339-21.8-6.629-27.2,2.513C-2.89,30.772,1.8,39.579,4.11,38.014c2.443-1.643-5.278-5.074.317-14.558,5.348-8.948,14.014-8.73,19.959-5.25,8.362,5.354,7.646,10.788,9.961,9.217,1.665-1.136-1.253-1.745,1.548-9.829,1.81-5.206,8.818-11.1,13.355-13.43C55.5,1.2,63.213,2.027,70.232,9.024c3.812,4.408,4.042,7.566,5.942,6.271,1.665-1.122-2.961-6.821-4.241-8.164C60.009-8.1,37.074,3.549,32.786,18.892Z",
    transform: "translate(550.234 915.444)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3383",
    "data-name": "Fill 3383",
    d: "M1.046,15.583a1.317,1.317,0,0,0,1.82-.16c.772-.915-.215-1.792-.156-4.672C2.966,7.7,4.717,3.407,7.639,2.6c4.934-.806,10,6.21,11.19,7.231,1.214,1.042,3-.776,1.656-1.934-1.349-1.128-2.969-3.915-7-6.339C1.875-5.4-2.123,13.024,1.046,15.583",
    transform: "translate(623.1 918.738)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3384",
    "data-name": "Fill 3384",
    d: "M.454.486c.186.059.217.065,0,0",
    transform: "translate(286.664 1086.599)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3385",
    "data-name": "Fill 3385",
    d: "M83.963.1c-7.9.633-11.935,3.438-14.047,11.019C45.115-1.006,41.705,17.348,43.6,26.182c-.648-.269-1.379-.557-2.152-.9-9.593-4.237-13.272-3.471-13.2-3.471-9.479.135-22.738,10.252-25.933,19.318C-1.91,53.214-.792,72.306,9.327,83.058a1.272,1.272,0,1,0,1.654-1.932C2.018,71.344-6.585,39.091,21.467,25.954c10.446-4.971,19.726,2.966,23.249,3.352.534.9,1.154,1.346,1.781,1.131,2.572-.882-1.638-3.262-.576-11.1,1.563-11.673,10.947-11.449,21.963-6.4,8.069,3.728,1.039-8.576,14.763-10.187,8.271-.9,10.413,1.678,10.833-.6C94.01-.684,83.888.1,83.963.1Z",
    transform: "translate(223.783 1075.916)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3386",
    "data-name": "Fill 3386",
    d: "M29.435,7.794c-4.146,5.31.228,4.392-6.544.365-6.529-3.9-16.97.724-20.7,6.93C.674,17.587-.5,22.415.218,23.42a1.311,1.311,0,0,0,2.334-.495A14.658,14.658,0,0,1,6.67,13.247c1.853-1.476,7.2-4.172,10.887-4.105,7.259.523,8.3,7.633,11.03,4.848,1.091-1.112,7.394-18.457,27.62-8.229,6.134,3.156,5.346,4.986,6.671,5.221,9.207,1.608-17.942-23.094-33.443-3.187Z",
    transform: "translate(606.179 1103.288)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3387",
    "data-name": "Fill 3387",
    d: "M55.359.742C47.374,3.45,50.78,12.213,49.416,11.481c-16.744-8.9-26.659,3.282-25.452,13.739.317,2.756,1.936,1.314-6.337.663C3.44,24.731-4.235,33.541,2.436,50.176a1.29,1.29,0,0,0,2.44-.833C1,39.732,1.326,30.891,10.886,28.716c10.781-2.032,18.584,4.553,16.127-1.722-2.572-6.7,3.108-20.959,18.921-14.345,3.244,1.345,5.746,3.572,6.567,1.356.4-1.068-.672-4.26.168-7.3C54.25,2.326,61.354.336,68.182,5.878c1.314,1.061,2.966-.873,1.657-1.934C62.115-2.3,55.286.742,55.359.742",
    transform: "translate(300.731 1188.406)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3388",
    "data-name": "Fill 3388",
    d: "M19.816,10.646C13.329,4.584,1.877,7.7.4,18.855c-.413,3.125-.864,4.766.646,5.03,3.025.536.207-6.65,4.8-11.139C11,8.325,16.781,10.1,19.467,14.037c.21,2.515,2.476,2.7,2.977,1.483.492-1.19-.43-1.822-.417-2.422C22.414,8.655,26.192,2.448,32.171,2.56c6.17.47,8.326,4.241,10.122,1.423C43.8,1.639,41.038.6,40.307,2.145c-.252.527-.894-.659-6.012-1.818C23.168-2.2,19.966,10.786,19.816,10.646Z",
    transform: "translate(319.815 1129.621)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3389",
    "data-name": "Fill 3389",
    d: "M9.427,20.047c.65,4.574,2.782,2.474-1.237,3.811-7,2.325-14.574,15.421.715,26.663,1.472,1.078,2.909-1.014,1.654-1.936C.756,41.419.661,33.145,6.3,27.836c3.4-2.875,7.257-1.525,7.218-3.819.233-1.25-5.641-6.855,3.77-15.751,4.662-4.034,9.49-5.7,10.332-5.748C29.673,3.4,30.792,0,27.4,0,22.489,0,7.907,9.407,9.427,20.047Z",
    transform: "translate(471.539 916.327)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3390",
    "data-name": "Fill 3390",
    d: "M8.573.364c-6.591,1.7-10.606,12.359-7.509,12.9,2.808.49-.137-3.625,5.113-8.584,9.906-8.457,7.259,9.852,7.285,9.923,1.288,3.586,4.947-3.166,12.347-4.815,3.936-.759,9.124-.309,11.39,1.856,4.429,5.16-3.524,13,.174,13.651,1.415.251,1.558-1.349,1.659-1.714.246-.679,1.074-2.59,1.5-4.048C44.3,6.6,29.478,4.713,21,8.781c-5.79,2.779-4.579,4.612-4.55.8C16.564-2.808,7.627.364,8.573.364Z",
    transform: "translate(293.454 1007.229)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3391",
    "data-name": "Fill 3391",
    d: "M149.363,61.9C80.135,93.09-2.056,157.13.039,159.493c3.5,3.912,105.073-110.914,322.31-148.207,164.432-28.326-39.861-2.732-182.76,92-53.767,35.629-84.251,70.157-84.346,71.385-.488,6.736,43.511-45.365,139.1-86.815,70.665-30.646,131.542-45.842,164.92-49.97C194.287,85.536,55,208.658,77.065,192.011c30.672-23.109,28.045-23.767,82.155-58.546,130.58-83.8,222.561-97.375,222.636-97.4,18.173-8.844-99.851.059-228.208,69.011C93.115,137.882,54.065,176.3,88.339,145.243c26.3-23.829,75.031-57.214,132.729-83.348C366.584-3.988,387.712,8.06,387.629,1.055c-.156-6.625-144,18.457-238.266,60.848Z",
    transform: "translate(276.273 1161.041)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3392",
    "data-name": "Fill 3392",
    d: "M1.526,159.226c2.9,18.33,7.151,18.414,5.572,27.537-2.251,13.824-3.117,21.012-1.535,35.963,1.281,11.5,5.779,29.166,11.787,38,9.455,14.05,51.269,20.482,72.786,18.654,23.879-2.028,34.48-7.684,53.741-20.469,25.846-17.654,32.041-36,23.985-63.82C152.61,142.07,133.5,139.734,151.38,141.274c38.074,5.12,23.3,50.226,36.121,73.981,13.728,25.448,54.436,12.828,47.107-60.34-1.514-15.108-9.538-35.8-19.067-47.2-16.213-19.383-21.174-15.8-30.109-18.906-17.276-6.008-31.667-6.275-41.1-3.931-15.562,3.886-45.18,21.522-50.5,30.939-6.959-1.563-27.026,8.274-25.614,7.628-22.64,10.376-16.816,15.8-5.585-12.764,10.83-26.962,54.572-91.3,24.989-108.342C56-16.337-10.926,80.452,1.526,159.226",
    transform: "translate(358.952 895.852)",
    fill: "#bbd1db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3393",
    "data-name": "Fill 3393",
    d: "M15.628,1C12.047,12.489,5.517,7.838,3.64,3.974,2.468,1.393,2.532,1.078,1.905.742-2.231-1.408.611,9.458,8.083,11,15.63,12.6,20.5,0,16.937,0c-.855,0-1.419,1-1.309,1Z",
    transform: "translate(403.927 1097.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3394",
    "data-name": "Fill 3394",
    d: "M2.813,2.474C1.574.753-.783,2.581.259,4.03,11.61,19.76,19.746,1.479,17.15.122c-3.213-1.7-5.085,15.2-14.337,2.352",
    transform: "translate(474.927 1092.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3395",
    "data-name": "Fill 3395",
    d: "M.38,10.045C-1.1,17.5,12.843,15.807,20.2,13.312c4.918-1.654,6.671-6.705,2.561-10-10-8.055-25.37.343-22.377,6.738",
    transform: "translate(436.081 1108.356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3396",
    "data-name": "Fill 3396",
    d: "M0,10.35c-.062,1.218,1.2,1.161,1.371.531.236-.835.666-10.5.615-10.555C.163-1.7.092,6.2,0,10.35",
    transform: "translate(446.41 1123.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3397",
    "data-name": "Fill 3397",
    d: "M12.023,26.387h0C4.21,26.386.368,20.4.026,14.466a14.745,14.745,0,0,1,2.523-9.3A12,12,0,0,1,11.256.078,17.687,17.687,0,0,1,13.077,0a21.826,21.826,0,0,1,5.884.766A10.107,10.107,0,0,1,24.681,4.5a13.634,13.634,0,0,1,1.777,10.951c0-.018.012-.038.018-.061-.012.058-.027.112-.039.16.005-.034.013-.067.021-.1a.513.513,0,0,1-.066.143l.008,0h.019l-.009.043,0-.018-.03.134,0,.011-.015.06a15.632,15.632,0,0,1-2.826,5.715,10.878,10.878,0,0,1-4.788,3.57A20.286,20.286,0,0,1,12.023,26.387Z",
    transform: "translate(392.366 1120.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3398",
    "data-name": "Fill 3398",
    d: "M.263,10.6c-3.018,15.152,20.858,18.714,23.628,3.728C26.639-.974,3.713-6.665.263,10.6",
    transform: "translate(476.337 1115.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3399",
    "data-name": "Fill 3399",
    d: "M2.542.734C-.72,2.812-1.127,9.509,3,11.233c4.2,1.742,7.347-2.282,7.031-6.22C9.4-2.62,1.829.734,2.542.734",
    transform: "translate(441.763 1133.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3400",
    "data-name": "Fill 3400",
    d: "M8.773.035C-1.722,1.146-3.032,14.469,6.1,11.677c4.359-.251,10.057-5.8,7.293-9.831C11.833-.4,8.7.035,8.773.035",
    transform: "translate(397.555 1072.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3401",
    "data-name": "Fill 3401",
    d: "M2.031,8.967c4.708,5.011,11.27,3.878,11.27-.824A8.414,8.414,0,0,0,7.612.562c-6.049-2.406-10.327,3.386-5.58,8.4",
    transform: "translate(474.963 1063.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3402",
    "data-name": "Fill 3402",
    d: "M1.144.921C.128,5.011-.705,6.52.9,6.951c1.779.479,1.856-1.813,2.736-5.362A1.27,1.27,0,0,0,2.406,0,1.3,1.3,0,0,0,1.144.921",
    transform: "translate(472.56 1021.635)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3403",
    "data-name": "Fill 3403",
    d: "M.844.926C-.178,5.352-.08,5.617.154,6a1.31,1.31,0,0,0,2.36-.3C3.254,1.933,3.954.457,2.435.05A1.309,1.309,0,0,0,.844.926",
    transform: "translate(468.439 1045.271)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3404",
    "data-name": "Fill 3404",
    d: "M1.147.369C.758.747.781,1.186.659,2.109.226,4.911-.7,6.434.9,6.861S2.691,5.386,2.976,3.812c.443-2.4.54-2.917,0-3.443a1.344,1.344,0,0,0-1.828,0Z",
    transform: "translate(464.727 1063.579)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3405",
    "data-name": "Fill 3405",
    d: "M1.241.192c-.806.456-2.609,7.82.578,6.031.741-.428.529-.807.978-2.811C3.817-1.181,1.168.192,1.241.192",
    transform: "translate(462.364 1077.797)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3406",
    "data-name": "Fill 3406",
    d: "M.849,6.865c1.958.526,1.429-1.8,2.637-5.271A1.27,1.27,0,0,0,2.242,0C.321,0-.913,6.391.849,6.865",
    transform: "translate(459.407 1092.04)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3407",
    "data-name": "Fill 3407",
    d: "M.946.168c-.654.374-.7.949-.835,2.507C-.019,4.152-.322,5.8,1.28,5.8,2.856,5.8,2.519,4.1,2.755,2.211,3.2-.87.79.168.946.168",
    transform: "translate(453.564 1019.148)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3408",
    "data-name": "Fill 3408",
    d: "M1.23,7.357c1.548,0,1.555-1.9,1.555-6.111a1.293,1.293,0,0,0-2.585,0c.431,0-1.257,6.111,1.03,6.111",
    transform: "translate(452.89 1031.559)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3409",
    "data-name": "Fill 3409",
    d: "M.1,1.295C.071,2.941-.4,4.8,1.3,4.8A1.276,1.276,0,0,0,2.593,3.541C3.156-2.786-.67,1.295.1,1.295",
    transform: "translate(452.38 1046.771)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3410",
    "data-name": "Fill 3410",
    d: "M1.379,8.132c1.836,0,1.293-2.076,1.293-6.887a1.293,1.293,0,0,0-2.585,0c.371,0-1.03,6.887,1.293,6.887",
    transform: "translate(452.634 1061.75)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3411",
    "data-name": "Fill 3411",
    d: "M0,5.894a1.293,1.293,0,0,0,2.585,0c.054-2.9.1-2.473.234-4.651a1.294,1.294,0,0,0-2.587,0c.075,0-.163.806-.233,4.651",
    transform: "translate(453.011 1077.491)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3412",
    "data-name": "Fill 3412",
    d: "M1.051.14C.321.563.456.7,0,5.126A1.274,1.274,0,0,0,1.3,6.383c1.571,0,1.231-1.545,1.654-4.822C3.279-.659.567.14,1.051.14Z",
    transform: "translate(452.229 1093.135)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3413",
    "data-name": "Fill 3413",
    d: "M3.013,6.139c.309-.511.155-.734-.269-3.388C2.645,1.7,2.992,0,1.406,0-1.649,0,.921,9.59,3.013,6.139",
    transform: "translate(433.28 1020.417)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3414",
    "data-name": "Fill 3414",
    d: "M1.458,5.232c1.805,0,1.216-2.15,1.128-3.987A1.293,1.293,0,0,0,0,1.246c.269,0-.6,3.987,1.457,3.987",
    transform: "translate(435.089 1037.978)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3415",
    "data-name": "Fill 3415",
    d: "M.513,5.377a1.322,1.322,0,0,0,1.828,0c.628-.614.244-.687.244-4.132A1.293,1.293,0,0,0,0,1.245c.085,0-.228,3.41.513,4.132",
    transform: "translate(436.96 1051.875)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3416",
    "data-name": "Fill 3416",
    d: "M.593,6.545a1.316,1.316,0,0,0,1.825,0c.58-.557.329-.483.168-5.3A1.293,1.293,0,0,0,0,1.246c.174,0-.225,4.5.593,5.3",
    transform: "translate(439.47 1069.366)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3417",
    "data-name": "Fill 3417",
    d: "M.676,5.781a1.322,1.322,0,0,0,1.83,0c.7-.685.226-.9.081-4.53A1.294,1.294,0,0,0,0,1.25c.09,0-.049,3.817.676,4.53",
    transform: "translate(441.281 1082.271)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3418",
    "data-name": "Fill 3418",
    d: "M1.822,4.962c1.38-.373.781-1.581.763-3.716A1.293,1.293,0,0,0,0,1.246c.192,0-.547,4.332,1.822,3.716Z",
    transform: "translate(442.316 1094.959)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3419",
    "data-name": "Fill 3419",
    d: "M1.235,6.65a1.292,1.292,0,0,0,2.494-.669C2.454.887,2.614,0,1.222,0c-2.237,0-.89,3.039.013,6.65",
    transform: "translate(415.893 1026.461)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3420",
    "data-name": "Fill 3420",
    d: "M.894.031C-.7.456.123,1.84,1.142,7.2a1.313,1.313,0,0,0,2.364.3c.309-.513.262-.824-1.021-6.586C2.223-.257.7.031.894.031",
    transform: "translate(420.808 1043.368)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3421",
    "data-name": "Fill 3421",
    d: "M.038,1.258C.1,2.341.786,8.7,1.752,9.243A1.315,1.315,0,0,0,3.52,8.79c.392-.658.049-.957-.757-5.846C2.592,1.533,2.815,0,1.33,0,.283,0-.135,1.258.038,1.258",
    transform: "translate(424.593 1059.535)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3422",
    "data-name": "Fill 3422",
    d: "M1.892,9.03c2.019,0,1.073-1.983.7-7.784A1.294,1.294,0,0,0,0,1.246c.391,0-.466,7.784,1.89,7.784",
    transform: "translate(428.19 1076.197)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3423",
    "data-name": "Fill 3423",
    d: "M.04,1.258c.189,2.6.133,5.686,2.116,5.16a1.26,1.26,0,0,0,.9-1.548C2.419,1.805,3.071,0,1.333,0,.278,0-.139,1.258.04,1.258",
    transform: "translate(430.902 1092.328)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3424",
    "data-name": "Fill 3424",
    d: "M.941.029C-1.311.615.971,6.141,2.663,3.351,2.979,2.827,2.791,2.3,2.531.9,2.324-.246.8.029.941.029",
    transform: "translate(433.402 1102.54)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3425",
    "data-name": "Fill 3425",
    d: "M1.467,5.514c1.88,0,1.053-2,1.143-4.268a1.293,1.293,0,0,0-2.585,0c.194,0-.7,4.268,1.442,4.268",
    transform: "translate(426.788 1032.223)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3426",
    "data-name": "Fill 3426",
    d: "M.561,4.991a1.292,1.292,0,0,0,2.494-.669C2.4,1.336,2.793,0,1.266,0-.622,0,.014,2.494.561,4.991",
    transform: "translate(428.571 1046.508)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3427",
    "data-name": "Fill 3427",
    d: "M0,1.246C.1,8.532,3.158,6.454,2.87,4.411a25.729,25.729,0,0,1-.285-3.165A1.293,1.293,0,0,0,0,1.246Z",
    transform: "translate(431.64 1061.614)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3428",
    "data-name": "Fill 3428",
    d: "M.923.028c-2.214.6.029,6.539,1.783,3.645.317-.523.129-.967-.192-2.766C2.316-.243.8.028.923.028",
    transform: "translate(433.869 1073.889)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3429",
    "data-name": "Fill 3429",
    d: "M.373.356C-.182.9-.015,1.121.22,4.189A1.274,1.274,0,0,0,1.512,5.446c1.8,0,1.273-2.175,1.065-4.2C2.365-.877.024.356.373.356",
    transform: "translate(436.09 1083.603)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3430",
    "data-name": "Fill 3430",
    d: "M1.329,4.211c1.581,0,1.258-1.6,1.258-2.966A1.294,1.294,0,0,0,0,1.245c.2,0-.6,2.966,1.328,2.966",
    transform: "translate(438.264 1096.29)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3431",
    "data-name": "Fill 3431",
    d: "M.384.918C-1.165,7.8,2.468,5.973,2.54,4.555,2.65,2.007,3.57,0,1.646,0A1.285,1.285,0,0,0,.384.918",
    transform: "translate(441.668 1022.167)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3432",
    "data-name": "Fill 3432",
    d: "M.722,8.616A1.278,1.278,0,0,0,2.014,9.874c2.487,0,.674-4.185.571-8.628A1.293,1.293,0,0,0,0,1.247L.722,8.616Z",
    transform: "translate(442.299 1035.81)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3433",
    "data-name": "Fill 3433",
    d: "M1.437,6.134C3.311,6.134,2.7,3.7,2.588,1.242A1.294,1.294,0,0,0,0,1.242c.313,0-.731,4.892,1.436,4.892",
    transform: "translate(443.891 1050.775)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3434",
    "data-name": "Fill 3434",
    d: "M1.353,4.993c1.677,0,1.279-1.945,1.279-3.747a1.294,1.294,0,0,0-2.587,0c.277,0-.829,3.747,1.307,3.747",
    transform: "translate(444.627 1060.783)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3435",
    "data-name": "Fill 3435",
    d: "M1.431,4.038c1.843,0,1.384-2.909.768-3.508C-.11-1.744-.963,4.038,1.431,4.038",
    transform: "translate(445.402 1069.094)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3436",
    "data-name": "Fill 3436",
    d: "M1.382,4.965c1.683,0,1.226-1.791,1.226-3.72a1.293,1.293,0,0,0-2.585,0c.233,0-.723,3.72,1.359,3.72",
    transform: "translate(446.306 1076.788)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3437",
    "data-name": "Fill 3437",
    d: "M1.306,4.048c1.5,0,1.293-1.553,1.293-2.8a1.293,1.293,0,0,0-2.585,0c.212,0-.65,2.8,1.293,2.8",
    transform: "translate(446.958 1084.836)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3438",
    "data-name": "Fill 3438",
    d: "M.575.372C.042.9,0,3.44,0,4.121a1.293,1.293,0,0,0,2.585,0c0-2.676.534-3.052-.182-3.749a1.336,1.336,0,0,0-1.828,0",
    transform: "translate(447.183 1090.919)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3439",
    "data-name": "Fill 3439",
    d: "M0,5.623a1.3,1.3,0,0,0,2.207.89c.457-.441.334-.77.593-3.095C3.075,1.931,3.8.454,2.312.057.324-.477.244,2.849,0,5.623",
    transform: "translate(462.447 1025.666)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3440",
    "data-name": "Fill 3440",
    d: "M.942.363C.446.847.589,1.412.34,3.6c-.33,2.907-.571,3.13.024,3.71C3.062,9.969,3.4.97,2.769.363a1.357,1.357,0,0,0-1.826,0",
    transform: "translate(461.721 1036.717)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3441",
    "data-name": "Fill 3441",
    d: "M1.305,4.96c1.638,0,1.33-2.036,1.4-3.712a1.293,1.293,0,0,0-2.585,0c.283,0-1,3.712,1.185,3.712",
    transform: "translate(461.11 1048.075)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3442",
    "data-name": "Fill 3442",
    d: "M1.344.127C.657.52.751.93.439,2.8c-.352,2.1-.63,2.5-.272,3.088a1.31,1.31,0,0,0,2.36-.3c.666-3.472.324-1.695.715-4.035C3.6-.63.88.127,1.344.127",
    transform: "translate(459.805 1059.313)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3443",
    "data-name": "Fill 3443",
    d: "M.9,6.306c1.9.51,1.638-1.877,2.222-4.719A1.291,1.291,0,0,0,.633.92C.972.92-1.141,5.754.9,6.306",
    transform: "translate(458.599 1069.127)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3444",
    "data-name": "Fill 3444",
    d: "M.754.363C.3.8.168,2.429,0,4.7a1.293,1.293,0,0,0,2.585,0c.251-3.453.679-3.674-.008-4.333a1.357,1.357,0,0,0-1.826,0",
    transform: "translate(457.718 1076.399)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3445",
    "data-name": "Fill 3445",
    d: "M.948.141C.3.507.225,1,.093,3.232,0,4.9-.342,6.788,1.3,6.788c1.794,0,1.087-1.926,1.542-5.225C3.171-.661.437.141.948.141",
    transform: "translate(456.696 1086.624)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3446",
    "data-name": "Fill 3446",
    d: "M1.3,3.868c1.5,0,1.294-1.582,1.294-2.622A1.294,1.294,0,0,0,0,1.245c.2,0-.6,2.622,1.293,2.622",
    transform: "translate(447.046 1099.192)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3447",
    "data-name": "Fill 3447",
    d: "M0,1.246c-.09,2.562,2.479,2.686,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(439.397 1102.195)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3448",
    "data-name": "Fill 3448",
    d: "M.919,4.2c1.843.493,3.038-4.2.75-4.2C0,0-.7,3.765.919,4.2",
    transform: "translate(454.772 1101.479)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3449",
    "data-name": "Fill 3449",
    d: "M.908,3.9C2.767,4.4,3.866,0,1.646,0,.067,0-.741,3.462.908,3.9",
    transform: "translate(459.744 1102.434)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3450",
    "data-name": "Fill 3450",
    d: "M.671.368C.2.83-1.04,6.927,1.849,5.289c.677-.389.566-.529,1.029-4.031A1.269,1.269,0,0,0,1.586,0,1.314,1.314,0,0,0,.671.368",
    transform: "translate(470.89 1033.518)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3451",
    "data-name": "Fill 3451",
    d: "M.963,3.978C2.778,4.464,3.075,1.48,2.64.764c-1.6-2.7-4,2.588-1.677,3.213",
    transform: "translate(466.298 1056.543)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3452",
    "data-name": "Fill 3452",
    d: "M1.277,3.371c1.312,0,1.3-1.265,1.34-2.128a1.294,1.294,0,0,0-2.587,0c.117,0-.557,2.128,1.247,2.128",
    transform: "translate(453.972 1055.465)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3453",
    "data-name": "Fill 3453",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(452.503 1072.494)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3454",
    "data-name": "Fill 3454",
    d: "M0,1.246a1.294,1.294,0,0,0,2.587,0A1.294,1.294,0,0,0,0,1.246",
    transform: "translate(439.044 1078.933)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3455",
    "data-name": "Fill 3455",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(439.861 1092.131)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3456",
    "data-name": "Fill 3456",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(452.757 1087.461)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3457",
    "data-name": "Fill 3457",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(460.472 1087.669)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3458",
    "data-name": "Fill 3458",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(437.895 1062.357)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3459",
    "data-name": "Fill 3459",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(428.429 1055.846)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3460",
    "data-name": "Fill 3460",
    d: "M0,1.247a1.294,1.294,0,0,0,2.587,0A1.294,1.294,0,0,0,0,1.247",
    transform: "translate(436.026 1047.546)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3461",
    "data-name": "Fill 3461",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(427.651 1041.695)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3462",
    "data-name": "Fill 3462",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(433.978 1031.879)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3463",
    "data-name": "Fill 3463",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(442.591 1032.433)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3464",
    "data-name": "Fill 3464",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(446.758 1030.835)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3465",
    "data-name": "Fill 3465",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(424.043 1029.357)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3466",
    "data-name": "Fill 3466",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(419.467 1038.507)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3467",
    "data-name": "Fill 3467",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(448.492 1023.697)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3468",
    "data-name": "Fill 3468",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(448.377 1043.464)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3469",
    "data-name": "Fill 3469",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(458.116 1024.853)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3470",
    "data-name": "Fill 3470",
    d: "M0,1.246a1.294,1.294,0,0,0,2.587,0A1.294,1.294,0,0,0,0,1.246",
    transform: "translate(457.434 1038.298)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3471",
    "data-name": "Fill 3471",
    d: "M0,1.246a1.294,1.294,0,0,0,2.587,0A1.294,1.294,0,0,0,0,1.246",
    transform: "translate(466.664 1020.052)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3472",
    "data-name": "Fill 3472",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(466.392 1039.703)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3473",
    "data-name": "Fill 3473",
    d: "M0,1.246a1.294,1.294,0,0,0,2.587,0A1.294,1.294,0,0,0,0,1.246",
    transform: "translate(447.888 1058.537)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3474",
    "data-name": "Fill 3474",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(455.992 1050.51)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3475",
    "data-name": "Fill 3475",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(463.665 1054.135)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3476",
    "data-name": "Fill 3476",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(466.159 1031.651)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3477",
    "data-name": "Fill 3477",
    d: "M0,1.246a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(449.301 1103.375)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3478",
    "data-name": "Fill 3478",
    d: "M0,1.246a1.293,1.293,0,0,0,2.583,0A1.293,1.293,0,0,0,0,1.246",
    transform: "translate(442.186 1104.085)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3479",
    "data-name": "Fill 3479",
    d: "M0,1.245a1.293,1.293,0,0,0,2.585,0A1.293,1.293,0,0,0,0,1.245",
    transform: "translate(436.041 1106.63)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3480",
    "data-name": "Fill 3480",
    d: "M1.884,2.744C-4.582,10.294,7.16,19.7,13.575,12.218,20.033,4.668,8.3-4.746,1.884,2.744",
    transform: "translate(418.928 913.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3481",
    "data-name": "Fill 3481",
    d: "M1.362,1.985C-3.313,7.44,5.175,14.268,9.822,8.844,14.5,3.39,6.01-3.439,1.362,1.985",
    transform: "translate(405.995 945.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3482",
    "data-name": "Fill 3482",
    d: "M1.362,1.986C-3.313,7.441,5.175,14.268,9.821,8.844,14.5,3.389,6.01-3.438,1.362,1.986",
    transform: "translate(390.187 976.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3483",
    "data-name": "Fill 3483",
    d: "M6.108,19.91c11.506,5.251,21.156-9.7,11.576-17.539C3.531-6.437-7.293,11.521,6.108,19.91",
    transform: "translate(556.167 1077.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3484",
    "data-name": "Fill 3484",
    d: "M1.477,2.111c-5.043,5.842,4.047,13.207,9.044,7.4,5.051-5.836-4.039-13.2-9.044-7.4",
    transform: "translate(556.668 1041.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3485",
    "data-name": "Fill 3485",
    d: "M1.373,1.967C-3.32,7.411,5.15,14.27,9.8,8.864c4.7-5.439-3.768-12.3-8.426-6.9",
    transform: "translate(537.569 1014.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3486",
    "data-name": "Fill 3486",
    d: "M1.373,1.967C-3.32,7.411,5.15,14.27,9.8,8.864c4.7-5.439-3.768-12.3-8.426-6.9",
    transform: "translate(502.592 1011.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3487",
    "data-name": "Fill 3487",
    d: "M1.733,1.445a5.354,5.354,0,0,0,3.5,9.267,5.448,5.448,0,0,0,5.756-5.1C11.22.816,5.322-1.816,1.733,1.445",
    transform: "translate(380.574 1013.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3488",
    "data-name": "Fill 3488",
    d: "M24.307.071C1.016.071-2.539,19.7,1.361,21.663c-.376.6-.133,10.042,3.656,19.4,4.447,10.988,5.139,17.718,16.775,27.5,3.6,2.972,6.954,5.121,11.61,5.121,5.634,0,6.342-5.041,6.127-4.361.47-1.5,1.2.877,4.576-.1,3.576-.923,4.628-5.237,4.864-6.539-.055.317,7.019,3.86,9.712-4.621C64.12,40.934,44.592,10.183,44.638,10.26,37.561-1.513,20.662.071,24.307.071",
    transform: "translate(480.304 1139.806)",
    fill: "#bbd1db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3489",
    "data-name": "Fill 3489",
    d: "M6.39,49.43c9.7,19.915,23.6,28.984,27.82,20.482,2.009,2.761,8.043,2.964,10.229-4.27.02.073,13.588,7.241,12.087-15.486-.547-8.045-4.1-22.583-8.649-32.764C33.489-16.272-17.808,1.358,6.39,49.43",
    transform: "translate(396.479 1159.595)",
    fill: "#bbd1db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3490",
    "data-name": "Fill 3490",
    d: "M.851.065C-.839.619.4,2.289,1.067,4.252c.755,2.2.731,4.376,2.491,3.791C5.347,7.453,3.82,3.959,2.49.852A1.31,1.31,0,0,0,.851.065",
    transform: "translate(426.302 1222.325)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3491",
    "data-name": "Fill 3491",
    d: "M1.7,5.691c.313,1.266.267,1.771.975,2.123C6.423,9.653,3.274,0,1.22,0c-2.707,0-.156,3.121.483,5.691",
    transform: "translate(436.81 1217.707)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3492",
    "data-name": "Fill 3492",
    d: "M2.877,6.353a1.188,1.188,0,0,1-1.183-.848A20.627,20.627,0,0,0,.684,3.037C.2,1.988-.156,1.23.07.711A1.185,1.185,0,0,1,.86.122s0-.009.008-.014A.467.467,0,0,1,1.2,0c.538,0,1.636.611,2.947,4.7A1.186,1.186,0,0,1,4,5.811,1.4,1.4,0,0,1,2.877,6.353Z",
    transform: "translate(516.268 1202.194)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3493",
    "data-name": "Fill 3493",
    d: "M1.19.023C-1.273.168.508,7.455,2.733,5.039c.54-.591.324-.773-.168-3.845A1.254,1.254,0,0,0,1.19.023",
    transform: "translate(527.198 1195.802)",
    fill: "silver"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404NotFoundSleepingRabbit);
export default __webpack_public_path__ + "static/media/404-not-found-sleeping-rabbit.6db45dc4beb834f30fb6da525c31e0f8.svg";
export { ForwardRef as ReactComponent };